export default __webpack_public_path__ + "static/media/Preemptive Strike.9ed11bde.png";